import { render } from "./OrderApprovedTable.vue?vue&type=template&id=4cd64fcc&scoped=true"
import script from "./OrderApprovedTable.vue?vue&type=script&lang=js"
export * from "./OrderApprovedTable.vue?vue&type=script&lang=js"

import "./OrderApprovedTable.vue?vue&type=style&index=0&id=4cd64fcc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cd64fcc"]])

export default __exports__